import React from "react";
import clsx from "clsx";
import "./ContentTabs.scss";

const ContentTabs = ({ tabs, contentTab, setContentTab }) => {
  return (
    <div className="content-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={clsx("content-tab", { active: contentTab === tab.id })}
          onClick={() => setContentTab(tab.id)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default ContentTabs;
